export default __webpack_public_path__ + "static/media/truffle.2f715c75.png";